import React from 'react'

import Backend from '../utils/Backend'
import Notify from '../utils/Notify'
import Color from '../utils/Color'
import Name from '../utils/Name'


export default class GlobalPayments extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      website: props.website,
      paymentMethod: props.paymentMethod,
      variation: props.variation ? props.variation : null,
    }

  }

  componentDidMount() {
    const { paymentMethod } = this.state
    Backend.getPublicData(paymentMethod.id)
      .then((response) => {
        this.setState({ tokens: response.access_tokens, env: response.env })

        const libraryScriptTag = document.createElement("script")
        libraryScriptTag.src = "https://js.globalpay.com/4.1.3/globalpayments.js"
        libraryScriptTag.addEventListener("load", () => {
          // load 3ds lib after so it attaches its methods to main lib (otherwise its overwritten)
          const threeDSScriptTag = document.createElement("script")
          threeDSScriptTag.src = "/assets/js/globalpayments-3ds.min.js"
          threeDSScriptTag.addEventListener("load", () => this._setupForm())
          document.body.appendChild(threeDSScriptTag);
        })
        document.body.appendChild(libraryScriptTag);

      })
  }

  async getPaymentDetails(amount, customer){
    const { paymentDetails } = this.state
    return {
      customer,
      ...paymentDetails,
    };
  }


  _setupForm(){
    const { website, tokens, variation, env } = this.state

    const globalPayments = window.GlobalPayments
    globalPayments.configure({
      accessToken: tokens.card.value,
      apiVersion: "2021-03-22",
      env: env || "sandbox" // or "production"
    });

    this.setState({ globalPayments })

    const brandColor = "#ececec" // website.primary_color || "#19e68a";
    const hoverBrandColor = Color.brightness(website.primary_color, -10);
    const inputBorderColor = "#ececec" // "transparent"
    const inputTextColor = "#000" // '#5e6278';

    let styles = {
    "@font-face": [
      {
        "font-family": "'Poppins'",
        "font-style": "normal",
        "font-weight": "500",
        "font-display": "swap",
        "src": "url(https://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrJJfecg.woff2) format('woff2')",
      },
      {
        "font-family": "'Roboto'",
        "font-style": "normal",
        "font-weight": "400",
        "font-display": "swap",
        "src": "url(https://fonts.gstatic.com/s/roboto/v30/KFOmCnqEu92Fr1Mu4mxK.woff2) format('woff2')",
      }
    ],
      "input": {
        "background": `${brandColor}0D`,
        "border": `1px solid ${inputBorderColor} !important`,
        "border-radius": "0.475rem",
        "padding": "16px 13px",
        "min-height": "55px",
        "height": "55px",
        "font-size": "14.3px",
        "font-family":'"Poppins",sans-serif',
        "color": inputTextColor,
        "box-sizing": "border-box",
        "outline": "none",
      },
      "input::placeholder": {
        "color": "#a1a5b7",
      },
      "input:focus-visible": {
        "background-color": "white",
      },
      "input:-webkit-autofill": {
        "color": inputTextColor,
      },
      "input.card-cvv": {
        "text-align": "center",
      },
      "button": {
        "padding": "12px 24px",
        "font-weight": "600",
        "background-color": website.primary_color,
        "border": "none",
        "outline": "none",
        "color": "#ffffff",
        "font-size": "14.3px",
        "height": "45px",
        "min-height": "45px",
        "border-radius": "6.175px",
        "font-family":'"Poppins",sans-serif',
        "cursor": "pointer",
      },
      "button:hover": {
        "background-color": hoverBrandColor,
      },
    }

    // override styles for payment-widget variation
    if (variation === "payment-widget") {
      styles = {
        ...styles,
        "input": {
          ...styles.input,
          "padding": "9px 13px",
          "min-height": "39px",
          "height": "39px",
          "font-size": "14px",
          "background-color": "#fcfcfc",
          "border-radius": "6px",
          "font-family":'"Roboto",sans-serif',
          "color": "rgba(0, 0, 0, 0.87)",
        },
          "input::placeholder": {
            "color": "#B8B8B8",
        },
      }
    }

    const cardForm = globalPayments.ui.form({
      fields: {
        "card-number": {
          placeholder: "•••• •••• •••• ••••",
          target: "#card-number"
        },
        "card-expiration": {
          placeholder: "MM / YYYY",
          target: "#card-expiration"
        },
        "card-cvv": {
          placeholder: "•••",
          target: "#card-cvv"
        },
        "card-holder-name": {
          placeholder: "Cardholder Name",
          target: "#card-holder-name"
        },
        "submit": {
          text: this.props.purchaseTitle, // Change the text of the button
          target: "#submit-button",
          value: "Pay Now"
        }
      },
      styles: styles,
    });

    cardForm.on("token-error", (response) => {
      this.props.onCheckingOut(false)
      let error = "Invalid card entered, please check your card details and try again"
      if (response.reasons && response.reasons.length > 0) {
        error = response.reasons[0].message || error
      }
      Notify.error(error);
    });

    cardForm.on("token-success", (response) => this._handlePay(response));

    cardForm.on("click", () => {
      this.props.onCheckingOut(true)
    })
  }

  async _check3DS(response) {
    const { globalPayments, paymentMethod, tokens } = this.state;
    const { amount, shop, email } = this.props

    const {
      checkVersion,
      initiateAuthentication,
      ChallengeWindowSize
    } = globalPayments.ThreeDSecure;

    const actionUrl = `${window.Api.CompanyProcessors}/${paymentMethod.id}/action`

    const currencyCode = shop.currency
    let versionCheckData = null
    try {
      const origin = window.location.origin
      const returnUrl = `${origin}/api/3ds/global-payments?&acs=1`
      versionCheckData = await checkVersion(actionUrl, {
        action: "check_enrollment",
        // todo make dynamic when GB possible
        country: "IE",
        currency_code: currencyCode,
        amount: amount,
        email: email,
        payment_reference: response.paymentReference,
        payment_access_token: tokens.payment.value,
        challenge_return_url: returnUrl,
        three_ds_method_return_url: returnUrl,
      });

    }catch(error) {
      return null
    }

    if (versionCheckData.status === "NOT_ENROLLED" && versionCheckData.liabilityShift !== "YES") {
      throw { message: "Your card has not been setup for Secure Payments, please try another card"}
    }

    try {
      const authenticationResult = await initiateAuthentication(actionUrl, {
        action: "authentication",
        payment_reference: response.paymentReference,
        payment_access_token: tokens.payment.value,
        // todo make dynamic when GB possible
        country: "IE",
        currency_code: currencyCode,
        amount: amount,
        email: email,
        shop_url: window.location.origin,
        version_check_data: versionCheckData,
        // for API to send correct size
        challenge_window: {
          window_size: ChallengeWindowSize.Windowed600x400,
          display_mode: "lightbox",
        },
        // for sdk to show lightbox
        challengeWindow: {
          windowSize: ChallengeWindowSize.Windowed600x400,
          displayMode: "lightbox",
        }
      })

      console.log("AR: ", authenticationResult)
      if(authenticationResult.status === "FAILED") {
        return null
      }
    }catch(error) {
      return null
    }
    return versionCheckData.serverTransactionId;
  }

  async _handlePay(response) {
    const cardholderName = response.details.cardholderName;
    if (!cardholderName) {
      this.props.onCheckingOut(false)
      Notify.error("Please enter the Cardholder Name");
      return;
    }

    const firstName = Name.getFirstName(cardholderName);
    const lastName = Name.getLastName(cardholderName);
    if (!firstName || !lastName) {
      this.props.onCheckingOut(false)
      Notify.error("Please enter the full Cardholder Name");
      return;
    }

    if(!this.props.isFormValid()){
      this.props.onCheckingOut(false)
      return
    }

    let serverTransactionId = null

    try {
      this.props.onCheckingOut(true)
      serverTransactionId = await this._check3DS(response)
    }catch(error) {
      this.props.onCheckingOut(false)
      Notify.error(error.message);
      return
    }

    const customerDetails = {
      first_name: firstName,
      last_name: lastName,
    }

    const paymentDetails = {
      payment_token_id: response.paymentReference,
      access_tokens: this.state.tokens,
    };

    if(serverTransactionId){
      paymentDetails.server_transaction_id = serverTransactionId
    }

    console.log("PD: ", paymentDetails)

    // this.props.updateCustomer(customerDetails);
    this.setState({ paymentDetails })
    this.props.onPayPressed();
  }

  render(){
    let {
      paymentMethod,
      variation,
    } = this.state

    return (
      <div className={`global-payments-card-container ${variation? `variation-${variation}` : ''  }`}>
        <div id="card-holder-name"></div>
        <div className="card-details">
          <div id="card-number"></div>
          <div id="card-expiration"></div>
          <div id="card-cvv"></div>
        </div>
        <div id="submit-button"></div>
      </div>
    )
  }
}
